export const REQUIRED_PASSENGER_DOCUMENTS = Object.freeze(["TERMS_PASSENGER", "PRIVACY_NOTICE"]);

export function canContinueLegal(acceptances) {
  return REQUIRED_PASSENGER_DOCUMENTS.every((type) => acceptances?.[type] === true);
}

export function nextExperiencePhase({ legalReady, locationPrimer, notificationPrimer }) {
  if (!legalReady) return "legal";
  if (!locationPrimer) return "location";
  if (!notificationPrimer) return "notifications";
  return "done";
}

export function shouldStartPassiveLocation(permission) {
  return permission === "granted";
}
